/**
 * バリエーション画像ピッカー
 * 商品バリエーションに関連付けられた画像をスウォッチとして表示する機能
 */
class VariantImagePicker {
  constructor() {
    this.init();
  }

  init() {
    // バリエーションセレクトコンポーネントを監視
    document.addEventListener('DOMContentLoaded', () => {
      this.setupVariantImagePickers();
    });

    // Shopifyのセクション更新イベントを監視
    document.addEventListener('shopify:section:load', (event) => {
      this.setupVariantImagePickers();
    });

    // バリエーション変更イベントを監視
    document.addEventListener('variant:change', (event) => {
      this.updateVariantImage(event.detail.variant);
    });
  }

  setupVariantImagePickers() {
    console.log('バリエーション画像ピッカーの初期化を開始します');
    const variantSelects = document.querySelectorAll('variant-selects');
    console.log(`variant-selects要素の数: ${variantSelects.length}`);
    
    variantSelects.forEach(select => {
      const sectionId = select.dataset.section;
      console.log(`セクションID: ${sectionId}`);
      
      // 設定を直接指定
      const enableVariantImage = true;
      const optionNames = 'color,カラー,Color'.split(',').map(name => name.trim().toLowerCase());
      const imageSize = 50;
      const imageStyle = 'circle';
      const fallbackColor = '#f5f5f5';
      
      console.log('バリエーション画像ピッカー設定:', {
        enableVariantImage,
        optionNames,
        imageSize,
        imageStyle,
        fallbackColor
      });
      
      try {
        // 商品データを取得
        const productData = JSON.parse(select.querySelector('[type="application/json"]').textContent);
        
        // 各オプションフィールドセットを処理
        const fieldsets = select.querySelectorAll('fieldset');
        fieldsets.forEach(fieldset => {
          const legend = fieldset.querySelector('legend');
          if (!legend) return;
          
          const optionName = legend.textContent.split(':')[0].trim().toLowerCase();
          
          // 画像表示対象のオプションかチェック
          if (!optionNames.includes(optionName)) return;
          
          // 各ラジオボタンを処理
          const radioButtons = fieldset.querySelectorAll('input[type="radio"]');
          radioButtons.forEach(radio => {
            const label = fieldset.querySelector(`label[for="${radio.id}"]`);
            if (!label) return;
            
            const optionValue = radio.value;
            
            // このオプション値に関連する画像を検索
            const variantWithImage = this.findVariantWithOptionValue(productData, optionName, optionValue);
            
            if (variantWithImage && variantWithImage.featured_media) {
              // 画像URLを取得
              const imageUrl = variantWithImage.featured_media.preview_image.src;
              
              // スウォッチラベルに画像を設定
              const swatch = label.querySelector('.swatch') || this.createSwatchElement(label);
              swatch.style.setProperty('--swatch-size', `${imageSize}px`);
              swatch.style.setProperty('--swatch--background', `url(${imageUrl})`);
              swatch.classList.remove('swatch--unavailable');
              
              // 画像スタイルを適用
              swatch.classList.remove('swatch--square', 'swatch--rounded', 'swatch--polaroid');
              if (imageStyle !== 'circle') {
                swatch.classList.add(`swatch--${imageStyle}`);
              }
            } else {
              // 画像が見つからない場合はフォールバック
              const swatch = label.querySelector('.swatch') || this.createSwatchElement(label);
              swatch.style.setProperty('--swatch-size', `${imageSize}px`);
              swatch.style.setProperty('--swatch--background', fallbackColor);
              
              // 画像スタイルを適用
              swatch.classList.remove('swatch--square', 'swatch--rounded', 'swatch--polaroid');
              if (imageStyle !== 'circle') {
                swatch.classList.add(`swatch--${imageStyle}`);
              }
            }
          });
          
          // ドロップダウンの場合も同様に処理
          const dropdown = select.querySelector(`select[id^="Option-${sectionId}"]`);
          if (dropdown) {
            const options = dropdown.querySelectorAll('option');
            options.forEach(option => {
              const optionValue = option.value;
              const variantWithImage = this.findVariantWithOptionValue(productData, optionName, optionValue);
              
              if (variantWithImage && variantWithImage.featured_media) {
                const imageUrl = variantWithImage.featured_media.preview_image.src;
                option.dataset.optionSwatchValue = `url(${imageUrl})`;
              }
            });
          }
        });
      } catch (error) {
        console.error('バリエーション画像ピッカーの初期化中にエラーが発生しました:', error);
      }
    });

    // カスタムイベントを設定
    this.setupCustomEvents();
  }

  // カスタムイベントを設定
  setupCustomEvents() {
    document.querySelectorAll('variant-selects').forEach(select => {
      // ラジオボタンの変更を監視
      select.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.addEventListener('change', (event) => {
          if (event.target.checked) {
            this.handleVariantChange(select);
          }
        });
      });

      // セレクトボックスの変更を監視
      select.querySelectorAll('select').forEach(dropdown => {
        dropdown.addEventListener('change', () => {
          this.handleVariantChange(select);
        });
      });
    });
  }

  // バリエーション変更時の処理
  handleVariantChange(select) {
    try {
      const variantJson = select.querySelector('[data-selected-variant]');
      if (variantJson) {
        const variant = JSON.parse(variantJson.textContent);
        const event = new CustomEvent('variant:change', {
          detail: { variant },
          bubbles: true
        });
        select.dispatchEvent(event);
      }
    } catch (error) {
      console.error('バリエーション変更イベントの発行中にエラーが発生しました:', error);
    }
  }

  // バリエーション画像の更新
  updateVariantImage(variant) {
    if (!variant || !variant.featured_media) return;

    // 商品画像ギャラリーを更新
    const mediaGallery = document.querySelector('.product__media-list');
    if (mediaGallery) {
      const mediaItems = mediaGallery.querySelectorAll('.product__media-item');
      mediaItems.forEach(item => {
        item.classList.add('hidden');
      });

      const selectedMedia = mediaGallery.querySelector(
        `.product__media-item[data-media-id="${variant.featured_media.id}"]`
      );
      if (selectedMedia) {
        selectedMedia.classList.remove('hidden');
      }
    }
  }
  
  // スウォッチ要素を作成
  createSwatchElement(label) {
    const swatch = document.createElement('span');
    swatch.classList.add('swatch');
    
    // すでに存在するスウォッチを削除
    const existingSwatch = label.querySelector('.swatch');
    if (existingSwatch) {
      existingSwatch.remove();
    }
    
    label.prepend(swatch);
    return swatch;
  }
  
  // 指定されたオプション値を持つバリエーションを検索
  findVariantWithOptionValue(productData, optionName, optionValue) {
    try {
      // オプション名のインデックスを特定
      let optionIndex = -1;
      
      // productDataの構造を確認
      if (!productData.options && productData.length > 0 && productData[0].options) {
        // 配列形式の場合
        for (let i = 0; i < productData[0].options.length; i++) {
          if (productData[0].options[i].toLowerCase() === optionName) {
            optionIndex = i;
            break;
          }
        }
        
        if (optionIndex === -1) return null;
        
        // このオプション値を持つバリエーションを検索
        return productData.find(variant => {
          return variant[`option${optionIndex + 1}`] === optionValue && variant.featured_media;
        });
      } else if (productData.options) {
        // オブジェクト形式の場合
        for (let i = 0; i < productData.options.length; i++) {
          if (productData.options[i].toLowerCase() === optionName) {
            optionIndex = i;
            break;
          }
        }
        
        if (optionIndex === -1) return null;
        
        // このオプション値を持つバリエーションを検索
        return productData.variants.find(variant => {
          return variant[`option${optionIndex + 1}`] === optionValue && variant.featured_media;
        });
      }
      
      return null;
    } catch (error) {
      console.error('バリエーション検索中にエラーが発生しました:', error);
      return null;
    }
  }
  
  // セクションIDからブロック設定を取得
  getBlockSettings(sectionId) {
    // 設定を直接返す
    return {
      enable_variant_image: 'true',
      image_option_names: 'color,カラー,Color',
      image_size: 50,
      image_style: 'circle',
      fallback_color: '#f5f5f5'
    };
  }
}

// インスタンス化
document.addEventListener('DOMContentLoaded', () => {
  new VariantImagePicker();
});
